import React, { Component, Fragment } from 'react';
import { PageWrapper, ErrorRedirect, PageLoader, SocialShare, RelatedPosts, Hero, Press, HelmetWrap} from './../components';
import ExPubDetail from './ex-pub-gallery/ExPubDetail';

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      wpData: {},
      loading: true,
      error: false
    };
    this.slug = `${process.env.API_URL}publication/?name=`;
  }

  componentDidMount() {
    this._apiRequest(`${this.slug}${this.props.match.params.pageSlug}`);
  }
  
  componentWillReceiveProps(nextProps) {
    this._apiRequest(`${this.slug}${nextProps.match.params.pageSlug}`);
  }

  _apiRequest(url) {
    fetch(url).then((response) => {
      if (!response.ok) { throw Error(response.statusText); }
      return response.json();
    }).then((res) => {
      this.setState({
        wpData: res.data,
        loading: false,
        error: false
      });
    }).catch(() => {
      this.setState({
        error: true,
        loading: false,
        wpData: false
      });
    });
  }

  render() {
    return (
      <Fragment>
        {(this.state.loading) ? <PageLoader/> : (this.state.error) ? <ErrorRedirect/>
          : <PublicationContent data={this.state.wpData}/>
        }
      </Fragment>
    );
  };
};

const PublicationContent = (props) => {
  return (
    <PageWrapper pageId={'publication-detail'}>
      <ExPubDetail data={props.data}>
        <div>
          <h2 className="medium-header publication-subhead" dangerouslySetInnerHTML={{ __html: props.data.description }} />
          <div className="text" dangerouslySetInnerHTML={{ __html: props.data.publisher_info }} />
        </div>
      </ExPubDetail>
      <SocialShare Meta={props.data.page_meta} />
      <RelatedPosts Posts={props.data.related_posts.posts}/>
    </PageWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/pages/SinglePublication.js